/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { Faq } from 'ui/atoms/Faq/Faq';
import { CtaSection } from 'ui/organisms/CtaSection/CtaSection';

import { CrmDataEnrichmentHero } from 'landing-pages/crm-data-enrichment/sections/CrmDataEnrichmentHero/CrmDataEnrichmentHero';
import { CrmDataEnrichmentProblem } from 'landing-pages/crm-data-enrichment/sections/CrmDataEnrichmentProblem/CrmDataEnrichmentProblem';
import { CrmDataEnrichmentProcess } from 'landing-pages/crm-data-enrichment/sections/CrmDataEnrichmentProcess/CrmDataEnrichmentProcess';
import { CrmDataEnrichmentFields } from 'landing-pages/crm-data-enrichment/sections/CrmDataEnrichmentFields/CrmDataEnrichmentFields';
import { CrmDataEnrichmentCodes } from 'landing-pages/crm-data-enrichment/sections/CrmDataEnrichmentCodes/CrmDataEnrichmentCodes';
import { CrmDataEnrichmentPlatforms } from 'landing-pages/crm-data-enrichment/sections/CrmDataEnrichmentPlatforms/CrmDataEnrichmentPlatforms';
import { CrmDataEnrichmentFeed } from 'landing-pages/crm-data-enrichment/sections/CrmDataEnrichmentFeed/CrmDataEnrichmentFeed';

import styles from './CrmDataEnrichmentPage.module.scss';

import { getFaqData } from './CrmDataEnrichmentPage.data';

export const CrmDataEnrichmentPage = () => {
  const { t } = useInt();

  return (
    <div className={styles.wrapper}>
      <CrmDataEnrichmentHero />
      <CrmDataEnrichmentProblem />
      <CrmDataEnrichmentProcess />
      <CrmDataEnrichmentFields />
      <CrmDataEnrichmentCodes />
      <CrmDataEnrichmentPlatforms />
      <CrmDataEnrichmentFeed />
      <CtaSection
        spotlight
        title={t('Send us a sample of your CRM. We will show you the match rate before you buy anything.')}
        description={t(
          'Export a few thousand company records. We run them against the registers and return what matched, what has changed since import and what was missing.',
        )}
        actions={
          <Button type="blue" size="xl" href="/book-a-demo" suffixIcon="arrow-forward">
            {t('Send a sample file')}
          </Button>
        }
      />
      <Faq className={styles.faq} title={t('Ten answers, in the order they come up.')} data={getFaqData(t)} />
    </div>
  );
};
